import React, { useContext } from 'react';
import { DatabaseContext } from '../firebase/db';

function TopScore({hardMode = false}) {
  const {topScores} = useContext(DatabaseContext);
  return (
    <div>
      <h4>Top Score: {hardMode ? topScores.maxScoreHard : topScores.maxScore}</h4>
    </div>
  );
}

export default TopScore;
